import React, {useEffect, useState} from 'react';
import {useSelector} from "react-redux";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { useNavigate } from "react-router-dom";
import {courseFriendlyName} from "./courseContent/courseObjects";
import {END} from "./helpers/routes";

const ResumeCourse = () => {
  const navigate = useNavigate();
  const teamDetails = useSelector((state) => state.team?.teamDetails);
  const courseName = teamDetails?.currentCourseSelection;
  const courseProgress = courseName && teamDetails?.courseProgress?.[courseName];

  const [dialog, setDialog] = useState(false);

  useEffect(() => {
    if (courseProgress && !courseProgress.toString().includes(END)) {
      setDialog(true);
    } else {
      setDialog(false);
    }
  }, [courseProgress]);

  const handleResume = () => {
    if (courseProgress) {
      navigate(courseProgress);
    }
  };

  if (!teamDetails || !courseName || !courseProgress) {
    return null;
  }

  const friendlyName = courseFriendlyName(courseName) || 'your course';

  return (
      <Dialog onClose={() => setDialog(false)} open={dialog}>
        <DialogContent>
          <Typography>
            It looks like you are in the middle of the {friendlyName} course
          </Typography>
          <Button
              variant="contained"
              color="primary"
              onClick={handleResume}
              style={{width: '100%', marginTop: '24px'}}
          >
            Resume Course
          </Button>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialog(false)}>Cancel</Button>
        </DialogActions>
      </Dialog>
  );
};

export default ResumeCourse;
